<template>
    
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-4">
                    <div class="card mx-auto">            
                        <!-- <img src="/images/img.jpg" alt="" class="card-img-top">             -->
                        <img :src="course.image" alt="" class="card-img-top">            
                        <div class="card-body d-flex flex-column">
                            <div class="card__header--secondary mb-1">{{course.department.name}}</div>
                            <div class="d-inline-flex">
                                <!-- <span class="badge card__badge">NEW</span> -->
                                <span v-if="course.status_id == 1" class="badge badge-info ">в работе</span>
                                <span v-if="course.status_id == 5" class="badge badge-success ">завершён</span>
                            </div>
                            <div class="card__header--primary mb-1">{{course.name}}</div>
                            <div class="card__rating">
                                <!--
                                <span class="card__rating--filled">☆</span>
                                <span>☆</span>
                                <span>☆</span>
                                <span>☆</span>
                                <span>☆</span>
                                -->
                                <span :class="{'card__rating--filled' : course.rating >= 1}">☆</span>
                                <span :class="{'card__rating--filled' : course.rating >= 2}">☆</span>
                                <span :class="{'card__rating--filled' : course.rating >= 3}">☆</span>
                                <span :class="{'card__rating--filled' : course.rating >= 4}">☆</span>
                                <span :class="{'card__rating--filled' : course.rating >= 5}">☆</span>
                            </div>
                            <p>
                                <!-- Open the door to sought-after technology careers with a world-class online Bachelor of Science (BSc) in Computer Science degree from the University of London.  -->
                                {{course.description}}
                            </p>
                            <div class="mt-auto">
                                <div class="mb-3 d-flex card__icon-container">
                                    <!--
                                    <div class="mr-3">
                                        <img src="/images/waiting.svg" alt="" class="card__icon">
                                        <span >3 – 6 years</span>    
                                    </div>                
                                    -->
                                    <div>
                                        <img src="/images/clock.svg" alt="" class="card__icon">
                                        <!-- <span>14 to 28 hours per week</span> -->
                                        &nbsp;
                                        <span>{{course.duration}}</span>
                                    </div>
                                </div>                
                                <!-- <a href="#" class="btn card__button">Button</a> -->
                                <router-link class="btn card__button" :to="{ name: 'course_show', params: { id: course.id } }">Перейти к курсу</router-link>&nbsp;
                            </div>            
                        </div>
                    </div>
                </div>
</template>


<script>
export default {
    data() {
        return {

        }
    },
    props: {
        course: Object,
    },
}
</script>

<style scoped>

.card {
  transition: all .5s ease-in-out;
  background: #F5F7FA;
  max-width: 80%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.card-img-top {
  transition: all .5s ease-in-out;
  max-height: 30%;
  object-fit: cover;
}

.card:hover {
  background-color: #E4E7EB;
}

.card:hover .card-img-top {
  transform: scale(1.05);
}

.card__badge {
  color: #F5F7FA;
  font-weight: 700;
  padding: 6px 10px;
  background: #0B4F71;
}

.card__button {
  color: #F5F7FA;
  text-decoration: none;
  text-align: center;
  font-weight: 600;
  width: 100%;
  padding: 4px;
  background: #166086;
  display: inline-block;
}

.card__button:hover {
  color: #F5F7FA;
  background: #1D6F98;
}

.card__header--primary {
  color: #166086;
  font-weight: 600;
  font-size: 1.5em;
}

.card__header--secondary {
  font-size: 1.2em;
  font-weight: 600;
  color: #9AA5B1;
}

.card__rating {
  color: orange;
}

.card__rating > span {
  font-size: 30px;
  line-height: .5;
}

.card__rating--filled:before {
  content: "\2605";
  position: absolute;
}

.card__icon-container {
  flex-grow: 1;
}

.card__icon {
  width: 15px;
}

.to-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background-color: #1D6F98;
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 40px;
  line-height: 48px;
  width: 48px;
}

@media (min-width: 768px) {
  .card {
    max-width: 20rem;
  }
}

/*# sourceMappingURL=styles.css.map */

</style>

